// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"25":"token","146":"match","497":"config","535":"login","803":"train"}[chunkId] || chunkId) + "." + {"25":"f2cd8afd","32":"5a249e21","146":"a4f88ff3","165":"daa323fd","497":"0b81b456","535":"15bfced5","803":"8a9edae9"}[chunkId] + ".js";
};